import * as React from 'react';
import { DisplayDate } from 'owa-datetime';
import { observer } from 'mobx-react-lite';

let styles = require('owa-calendar-surface-dategrid/lib/surfaceItems/CalendarDateHeader.scss');
let classNames = require('classnames/bind').bind(styles);

export interface CalendarMonthDateHeaderProps {
    displayDate: DisplayDate;
    formatHeader: (date: DisplayDate) => string;
    style?: React.CSSProperties;
}

/**
 * This panel shows date headers for surface columns
 */
const CalendarMonthDateHeader = observer(function CalendarMonthDateHeader(
    props: CalendarMonthDateHeaderProps
) {
    let { displayDate, formatHeader } = props;
    let header = formatHeader(displayDate);

    return (
        <div className={classNames(styles.header, styles.monthHeader)} style={props.style}>
            <time title={header}>{header}</time>
        </div>
    );
});
export default CalendarMonthDateHeader;
